import React from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css";
import "swiper/css/effect-fade";
import { EffectFade, Autoplay } from "swiper/modules";

function LoginCarousel({ carouselItems }) {
  return (
    <>
      <Swiper
        spaceBetween={30}
        effect={"fade"}
        autoplay={{
            delay: 3000,
            disableOnInteraction: false,
          }}
        modules={[EffectFade, Autoplay]}
        className="mySwiper"
      >
        {carouselItems.map((item, index) => (
          <SwiperSlide key={index}>
            <div className="bg-white">
              <img src={item.img} alt="" />
              <div className="grid place-items-center">
                <p className="font-medium text-center">
                  {item.para}
                </p>
                <button className="bg-d-cat-btn rounded-full px-3 py-1 text-white font-medium text-sm mt-4">
                  {item.btn}
                </button>
              </div>
            </div>
          </SwiperSlide>
        ))}
      </Swiper>
    </>
  );
}

export default LoginCarousel;
